import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";

export interface ITransactionCertificateReqDto {
  tcId?: string;
  tcNo: string;
  tcVersionNo: string;
  tcOrganicFarmStandard: string[];
  tcStandard: string[];
  tcStatus: string;
  tcAmendmentReason: string;
  tcInvalidationReason: string;
  tcPlaceOfIssue: string;
  tcDateOfIssue: string;
  tcLastUpdated: string;
  tcCbLicensingCode: string;
  tcApplicationReceived: string;
  tcApplicationComplete: string;
  tcDelayReason: string;
  tcCreatedBy: string;
  tcUsdaNopCompliantFlag: string;
  isVersionUpdated: string;
  // Add description fields
  tcStatusDescription?: string;
  tcAmendmentReasonDescription?: string;
  tcInvalidationReasonDescription?: string;
  tcDelayReasonDescription?: string;
  tcStandardDescription?: string[];
  tcOrganicFarmStandardDescription?: string[];
}

export const transactionCertificateReqDto: ITransactionCertificateReqDto = {
  tcNo: "",
  tcAmendmentReason: "",
  tcVersionNo: "",
  tcOrganicFarmStandard: [],
  tcStandard: [],
  tcStatus: "",
  tcInvalidationReason: "",
  tcPlaceOfIssue: "",
  tcDateOfIssue: "",
  tcLastUpdated: "",
  tcCbLicensingCode: "",
  tcApplicationReceived: "",
  tcDelayReason: "",
  tcCreatedBy: "",
  tcApplicationComplete: '',
  tcUsdaNopCompliantFlag: '',
  isVersionUpdated: ''
}

export const mapToTransactionCertificateReqDto = (data?: any, TE_ID?: any, isVersionUpdated?: boolean, cbLicenseCode?: any, selectedDescriptions?: any, organicFarmStandardsData?: any): ITransactionCertificateReqDto => {
  return {
    ...(TE_ID ? { tcId: TE_ID } : {}),
    isVersionUpdated: isVersionUpdated ? "yes" : "no",
    tcNo: data.tcNo || '',
    tcVersionNo: data.tcVersionNo || '',
    tcOrganicFarmStandard: data.tcOrganicFarmStandard || [],
    tcStandard: data.tcStandard || [],
    tcStatus: data.tcStatus || '',
    tcStatusDescription: data.tcStatus === 'V' ? 'Valid' :
      data.tcStatus === 'I' ? 'Invalid' :
        data.tcStatus === 'A' ? 'Amended' : '',
    tcAmendmentReason: data.tcAmendmentReason || '',
    tcInvalidationReason: data.tcInvalidationReason || '',
    tcPlaceOfIssue: data.tcPlaceOfIssue || '',
    tcDateOfIssue: data.tcDateOfIssue || '',
    tcLastUpdated: data.tcLastUpdated || '',
    tcCbLicensingCode: cbLicenseCode || '',
    tcApplicationReceived: data.tcApplicationReceived || '',
    tcApplicationComplete: data.tcApplicationComplete || '',
    tcDelayReason: data.tcDelayReason || '',
    tcCreatedBy: data.tcCreatedBy || '',
    tcUsdaNopCompliantFlag: data.tcUsdaNopCompliantFlag || '',
    tcAmendmentReasonDescription: data.tcAmendmentReason === 'R' ? 'Reduction in the Quantity of Claimed Material' :
      data.tcAmendmentReason === 'T' ? 'Typographical Errors within Fourteen Calendar Days of Issuance' :
        data.tcAmendmentReason === 'G' ? 'Downgrade GRS to RCS, Upgrade RCS to GRS' :
          data.tcAmendmentReason === 'B' ? 'Corrections to Buyer Name and Address Information' :
            data.tcAmendmentReason === 'E' ? 'Reasons where Textile Exchange has Granted an Exemption' : '',
    tcInvalidationReasonDescription: data.tcInvalidationReason === 'F' ? 'Falsified Or Fraudulent Documents' :
      data.tcInvalidationReason === 'E' ? 'Certification Body Errors' :
        data.tcInvalidationReason === 'I' ? 'Applicable Input Transaction Has Been Invalidated' :
          data.tcInvalidationReason === 'M' ? 'Claimed Materials Are Shown To Be Ineligible' :
            data.tcInvalidationReason === 'S' ? 'Requests From The Seller' :
              data.tcInvalidationReason === 'O' ? 'Other Reason' : '',
    tcDelayReasonDescription: data.tcDelayReason === 'F' ? 'Falsified Or Fraudulent Documents' :
      data.tcDelayReason === 'E' ? 'Certification Body Errors' :
        data.tcDelayReason === 'I' ? 'Applicable Input Transaction Has Been Invalidated' :
          data.tcDelayReason === 'M' ? 'Claimed Materials Are Shown To Be Ineligible' :
            data.tcDelayReason === 'S' ? 'Requests From The Seller' :
              data.tcDelayReason === 'O' ? 'Other Reason' : '',

    // For multi-select fields
    tcStandardDescription: Array.isArray(data.tcStandard)
      ? data.tcStandard.map((code: string) => {
        const option = [
          { label: "Organic Content Standard (OCS)", value: "OCS" },
          { label: "Responsible Down Standard (RDS)", value: "RDS" },
          { label: "Responsible Alpaca Standard (RAS)", value: "RAS" },
          { label: "Global Recycled Standard (GRS)", value: "GRS" },
          { label: "Responsible Wool Standard (RWS)", value: "RWS" },
          { label: "Content Claim Standard (CCS)", value: "CCS" },
          { label: "Recycled Claim Standard (RCS)", value: "RCS" },
          { label: "Responsible Mohair Standard (RMS)", value: "RMS" },
          { label: "Sustainable Fiber Alliance (SFA)", value: "SFA" },
        ].find(opt => opt.value === code);
        return option?.label || "";
      })
      : (data.tcStandard ? [data.tcStandard] : []),

    tcOrganicFarmStandardDescription: selectedDescriptions?.tcOrganicFarmStandardDescription ||
      (Array.isArray(data.tcOrganicFarmStandard)
        ? data.tcOrganicFarmStandard.map((code: string) =>
          useTransactionCertificateStore.getState().getOrgFarmStandards.find(
            (option: any) => option.value === code
          )?.label || ""
        )
        : []),
  };
};